import { render, staticRenderFns } from "./VistaSeleccionPlantillaPersonalizada.vue?vue&type=template&id=28a76b48"
import script from "./VistaSeleccionPlantillaPersonalizada.vue?vue&type=script&lang=js"
export * from "./VistaSeleccionPlantillaPersonalizada.vue?vue&type=script&lang=js"
import style0 from "./VistaSeleccionPlantillaPersonalizada.vue?vue&type=style&index=0&id=28a76b48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VTextField})
